import * as amplitude from '@amplitude/analytics-browser';

interface FilterEventProps {
    filterType: string;
    modeType?: string;
}

function filterCollapsed({
    filterType,
    modeType,
}: FilterEventProps) {
    amplitude.track('search_interacted', {
        collapsed_filter: filterType,
        interaction_type: 'filter_collapsed',
        mode_type: modeType,
    });
}

function filterExpanded({
    filterType,
    modeType,
}: FilterEventProps) {
    amplitude.track('search_interacted', {
        expanded_filter: filterType,
        interaction_type: 'filter_expanded',
        mode_type: modeType,
    });
}

function filterListCollapsed({
    filterType,
}: FilterEventProps) {
    amplitude.track('search_interacted', {
        collapsed_filter_list: filterType,
        interaction_type: 'filter_list_collapsed',
    });
}

function filterListExpanded({
    filterType,
}: FilterEventProps) {
    amplitude.track('search_interacted', {
        expanded_filter_list: filterType,
        interaction_type: 'filter_list_expanded',
    });
}

function singleFilterReset({
    filterType,
}: FilterEventProps) {
    amplitude.track('search_interacted', {
        interaction_type: 'single_filter_reset',
        reset_filter: filterType,
    });
}

export default {
    filterCollapsed,
    filterExpanded,
    filterListCollapsed,
    filterListExpanded,
    singleFilterReset,
};
